import {Locale} from '@hebcal/hdate';
import poData from './nl.po.js';
Locale.addLocale('nl', poData);
